import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="address-validation"
export default class extends Controller {
  static targets = [
    'addressLine1',
    'addressLine2',
    'error1',
    'error2',
    'errorContainer1',
    'errorContainer2',
  ]

  declare readonly addressLine1Target: HTMLFormElement
  declare readonly addressLine2Target: HTMLFormElement
  declare readonly error1Target: HTMLElement
  declare readonly error2Target: HTMLElement
  declare readonly errorContainer1Target: HTMLElement
  declare readonly errorContainer2Target: HTMLElement

  validateAddress1 () {
    const address = this.addressLine1Target.value
    const pattern = '([Pp][ .]*[Oo])?[ .]?([Bb][Oo][Xx]) [0-9]+'
    if (address.match(pattern, 'i')) {
      this.error1Target.classList.remove('max-h-0')
      this.error1Target.classList.add('max-h-10')
      this.errorContainer1Target.classList.add('field-with-errors')
    } else {
      this.error1Target.classList.add('max-h-0')
      this.error1Target.classList.remove('max-h-10')
      this.errorContainer1Target.classList.remove('field-with-errors')
    }
  }

  validateAddress2 () {
    const address = this.addressLine2Target.value
    // we've seen some Box [0-9]+ items in address line 2 that correspond to (seemingly) valid addresses
    // so this regex doesn't treat PO as optional
    const pattern = '([Pp][ .]*[Oo].?)[ .]?([Bb][Oo][Xx]) [0-9]+'
    if (address.match(pattern, 'i')) {
      this.error2Target.classList.remove('max-h-0')
      this.error2Target.classList.add('max-h-10')
      this.errorContainer2Target.classList.add('field-with-errors')
    } else {
      this.error2Target.classList.add('max-h-0')
      this.error2Target.classList.remove('max-h-10')
      this.errorContainer2Target.classList.remove('field-with-errors')
    }
  }
}
